import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "pb-0 mb-0"
}
const _hoisted_3 = { class: "pt-2" }
const _hoisted_4 = {
  key: 0,
  class: "pl-4"
}
const _hoisted_5 = { class: "pl-4" }
const _hoisted_6 = { class: "pl-8 pr-0 py-0 ma-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.getIsEmpty(_ctx.isDeletable))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.isDeletable, (item1, index1) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index1,
            style: {"max-height":"90vh"}
          }, [
            (_ctx.getTypeof(item1) === 'string')
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(item1), 1))
              : (_ctx.getTypeof(item1) === 'object')
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(Object.keys(item1), (item2, indexTitle) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: indexTitle,
                      class: "my-2 px-2"
                    }, [
                      _createElementVNode("h3", _hoisted_3, _toDisplayString(item2), 1),
                      (item1[item2] && item1[item2].length && _ctx.getIsArray(item1[item2]))
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item1[item2], (array2, index2) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index2,
                              class: "py-2"
                            }, [
                              (_ctx.getTypeof(array2) === 'string')
                                ? (_openBlock(), _createElementBlock("h4", _hoisted_4, _toDisplayString(array2), 1))
                                : (!_ctx.getIsArray(array2))
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(Object.keys(array2), (array3, index3) => {
                                      return (_openBlock(), _createElementBlock("div", { key: index3 }, [
                                        _createElementVNode("h4", _hoisted_5, _toDisplayString(array3), 1),
                                        (
                                            array2[array3] &&
                                            array2[array3].length &&
                                            _ctx.getIsArray(array2[array3])
                                        )
                                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(array2[array3], (line, index4) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: index4,
                                                class: "pa-0 ma-0"
                                              }, [
                                                _createElementVNode("p", _hoisted_6, _toDisplayString(line), 1)
                                              ]))
                                            }), 128))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                : _createCommentVNode("", true)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}